import style from "./badge.module.scss"

export default function Badge({className,children}) {
  return (
    <span className={`${style.badge} ${className}`}>
      {children}
    </span>
  )
}
